<template>
  <div>
    <BaseButton
      :text="LABEL_CONSTANTS.BACK_TO_YOUR_DETAILS"
      flat
      ripple
      class="font-weight-semi-bold d-flex back-btn back-previous__btn-link pa-0 mb-sm-5"
      icon="mdi-chevron-left"
      color="#106175"
      small
      @click="backToYourDetail"
    />
    <v-row class="mb-3">
      <v-col class="d-flex justify-space-between flex-wrap section-title">
        <div>
          <h1 class="font-28 font-weight-bold black2-color">
            Property details
          </h1>
        </div>
        <BaseButton
          text="Save &amp; exit"
          flat
          depressed
          ripple
          class="font-weight-semi-bold d2c-save-exit mt-2 py-3 d-flex"
          icon="mdi-content-save"
          color="#106175"
          small
          @click="saveAndExit"
        />
      </v-col>
    </v-row>
    <ValidationObserver
      ref="observerFormPropertyDetails"
      v-slot="{ validate, invalid }"
    >
      <v-form
        ref="form"
        @submit.prevent="validate().then(() => onSubmit(invalid))"
      >
        <LayoutAddressSearch
          :addressFinderInputDescription="ADDRESS_FINDER_INPUT_DESCRIPTION"
        />

        <BaseLabel
          :text="LABEL_CONSTANTS.WINDOW_LOCKS_FITTED"
          :helpText="LABEL_CONSTANTS.WINDOW_LOCKS_FITTED_HELP_TEXT"
        ></BaseLabel>
        <BaseToggleButton
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          minWidth="110px"
          v-model="form.windowLocksFitted.Value"
          :toggleButtonText="{
            yesDataUiid: 'WindowLocksFitted_Yes',
            noDataUiid: 'WindowLocksFitted_No',
          }"
          class="mb-9"
        />

        <BaseLabel
          :text="LABEL_CONSTANTS.ALARM_TYPE"
          :helpText="LABEL_CONSTANTS.ALARM_TYPE_HELP_TEXT"
          :hintText="LABEL_CONSTANTS.ALARM_TYPE_HINT"
        ></BaseLabel>
        <BaseSelect
          :rules="{
            required: {
              required: true,
              fieldLabel: LABEL_CONSTANTS.ALARM_TYPE,
            },
          }"
          :hideDetails="false"
          :items="alarmTypeOptions"
          :isEnableSortOrderListItems="false"
          v-model="form.alarmType.Value"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :dense="$vuetify.breakpoint.lgAndUp"
          data-uiid="AlarmType"
        />

        <BaseLabel
          :text="LABEL_CONSTANTS.UNOCCUPIED_NINETY_DAYS"
          :helpText="LABEL_CONSTANTS.UNOCCUPIED_NINETY_DAYS_HELP_TEXT"
          :hintText="LABEL_CONSTANTS.UNOCCUPIED_NINETY_DAYS_HINT"
          class="mt-3"
        ></BaseLabel>
        <BaseToggleButton
          v-model="form.unoccupiedNinetyDays.Value"
          class="mb-9"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
          :toggleButtonText="{
            yesDataUiid: 'UnoccupiedNinetyDays_Yes',
            noDataUiid: 'UnoccupiedNinetyDays_No',
          }"
        />

        <BaseLabel
          :text="LABEL_CONSTANTS.NON_ROUTINE_BUILDING_WORK"
          :helpText="LABEL_CONSTANTS.NON_ROUTINE_BUILDING_WORK_HELP_TEXT"
          :hintText="LABEL_CONSTANTS.NON_ROUTINE_BUILDING_WORK_HINT"
        ></BaseLabel>
        <BaseToggleButton
          v-model="form.nonRoutineBuildingWork.Value"
          class="mb-9"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
          :toggleButtonText="{
            yesDataUiid: 'NonRoutineBuildingWork_Yes',
            noDataUiid: 'NonRoutineBuildingWork_No',
          }"
        />

        <template v-if="form.nonRoutineBuildingWork.Value">
          <BaseLabel
            :text="LABEL_CONSTANTS.NON_ROUTINE_BUILDING_WORK_VALUE"
            :helpText="
              LABEL_CONSTANTS.NON_ROUTINE_BUILDING_WORK_VALUE_HELP_TEXT
            "
          ></BaseLabel>
          <BaseInput
            vid="NonRoutineBuildingWorkValue"
            moneyFormat
            prefix="£"
            v-model="form.nonRoutineBuildingWorkValue.Value"
            data-uiid="NonRoutineBuildingWorkValue"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
            :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
            :className="'mb-2 work-value__input'"
            :rules="{
              required: {
                required: true,
                fieldLabel:
                  LABEL_CONSTANTS.NON_ROUTINE_BUILDING_WORK_VALUE_LABEL_MSG,
              },
              max_value: {
                customMessage:
                  LABEL_CONSTANTS.NON_ROUTINE_BUILDING_WORK_VALUE_MAX_LABEL_MSG,
                max: 999999.99,
              },
              min_currency_value: {
                customMessage:
                  LABEL_CONSTANTS.NON_ROUTINE_BUILDING_WORK_VALUE_MIN_LABEL_MSG,
                minValue: 0,
              },
            }"
          />

          <BaseLabel
            :text="LABEL_CONSTANTS.NON_ROUTINE_BUILDING_WORK_JCT_CONTRACT"
            :helpText="
              LABEL_CONSTANTS.NON_ROUTINE_BUILDING_WORK_JCT_CONTRACT_HELP_TEXT
            "
          ></BaseLabel>
          <BaseToggleButton
            v-model="form.nonRoutineBuildingWorkJctContract.Value"
            class="mb-9"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
            :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
            :toggleButtonText="{
              yesDataUiid: 'NonRoutineBuildingWorkJctContract_Yes',
              noDataUiid: 'NonRoutineBuildingWorkJctContract_No',
            }"
          />
        </template>

        <BaseLabel
          :text="LABEL_CONSTANTS.STUDENT_TENANTS"
          :helpText="LABEL_CONSTANTS.STUDENT_TENANTS_HELP_TEXT"
        ></BaseLabel>
        <BaseToggleButton
          v-model="form.studentTenants.Value"
          class="mb-9"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
          :toggleButtonText="{
            yesDataUiid: 'StudentTenants_Yes',
            noDataUiid: 'StudentTenants_No',
          }"
        />

        <BaseLabel
          :text="LABEL_CONSTANTS.DSS_TENANTS"
          :helpText="LABEL_CONSTANTS.DSS_TENANTS_HELP_TEXT"
        ></BaseLabel>
        <BaseToggleButton
          v-model="form.dssTenants.Value"
          class="mb-9"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
          :toggleButtonText="{
            yesDataUiid: 'DssTenants_Yes',
            noDataUiid: 'DssTenants_No',
          }"
        />

        <BaseLabel
          :text="LABEL_CONSTANTS.NO_CLAIMS_BUILDINGS"
          :helpText="LABEL_CONSTANTS.NO_CLAIMS_BUILDINGS_HELP_TEXT"
          :hintText="LABEL_CONSTANTS.NO_CLAIMS_BUILDINGS_HINT"
        ></BaseLabel>
        <BaseRadio
          v-model="form.noClaimsBuildings.Value"
          pslStyle="button"
          class="mb-9"
          data-uiid="NoClaimsBuildings"
          :key="`${form.noClaimsBuildings.Value}_NoClaimsBuildings`"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :width="$vuetify.breakpoint.lgAndUp ? '72' : '100'"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          :className="'radio-group__wrapper'"
          :items="noClaimBuildingOptions"
          :disabled="!hasPreviousLandlordsCover"
          :rules="{
            required: {
              required: true,
              fieldLabel: LABEL_CONSTANTS.NO_CLAIMS_BUILDINGS_LABEL_MSG,
            },
          }"
        />
        <template v-if="!isBuildingsOnly">
          <BaseLabel
            :text="LABEL_CONSTANTS.NO_CLAIMS_CONTENTS"
            :helpText="LABEL_CONSTANTS.NO_CLAIMS_CONTENTS_HELP_TEXT"
            :hintText="LABEL_CONSTANTS.NO_CLAIMS_CONTENTS_HINT"
          ></BaseLabel>
          <BaseRadio
            v-model="form.noClaimsContents.Value"
            pslStyle="button"
            class="mb-10"
            data-uiid="NoClaimsContents"
            :key="`${form.noClaimsContents.Value}_NoClaimsContents`"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
            :width="$vuetify.breakpoint.lgAndUp ? '72' : '100'"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :className="'radio-group__wrapper'"
            :items="noClaimContentOptions"
            :disabled="!hasPreviousLandlordsCover"
            :rules="{
              required: {
                required: true,
                fieldLabel: LABEL_CONSTANTS.NO_CLAIMS_CONTENTS_LABEL_MSG,
              },
            }"
          />
        </template>

        <BaseButton
          rounded
          class="font-weight-bold continue-button primary--text"
          height="60"
          type="submit"
          :disabled="disableContinue"
          :text="
            $vuetify.breakpoint.lgAndUp
              ? LABEL_CONSTANTS.CONTINUE_TO_COVER
              : 'CONTINUE'
          "
          :color="'psorange'"
          :fontSize="'font-20'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '453' : '100%'"
        />
      </v-form>
    </ValidationObserver>
  </div>
</template>

<script>
import numeral from "numeral";
import { EventBus } from "@/common/eventbus.js";
import { ValidationObserver } from "vee-validate";
import { dereference } from "@/common/transforms";
import { includesContents } from "@/common/answers";
import { mapActions, mapGetters, mapState } from "vuex";
import { convertToBool, scrollTop, tryGoToNextStep } from "@/common/utils";

import {
  setItemDataUiids,
  ALARM_TYPE_ITEMS,
  NO_CLAIMS_BUILDINGS_ITEMS,
  NO_CLAIMS_CONTENTS_ITEMS,
} from "@/constants/component.constants";
import { ROUTE_NAME } from "@/constants/route.constants";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import * as LABEL_CONSTANTS from "@/constants/label.constants";
import { EXIT_DESTINATION } from "@/constants/common.constants";
import { PROPERTY_DETAILS_FORM } from "@/constants/form.constants";

import BaseButton from "@/components/BaseComponents/BaseButton.vue";
import BaseInput from "@/components/BaseComponents/BaseInput.vue";
import BaseLabel from "@/components/BaseComponents/BaseLabel.vue";
import BaseRadio from "@/components/BaseComponents/BaseRadio.vue";
import BaseSelect from "@/components/BaseComponents/BaseSelect.vue";
import BaseToggleButton from "@/components/BaseComponents/BaseToggleButton.vue";
import LayoutAddressSearch from "@/components/LayoutComponents/LayoutAddressSearch.vue";
import { ADDRESS_FINDER_INPUT_DESCRIPTION } from "@/constants/description.constants";

export default {
  name: "D2CLandlordPropertyDetailPage",
  components: {
    ValidationObserver,
    LayoutAddressSearch,
    BaseToggleButton,
    BaseLabel,
    BaseSelect,
    BaseInput,
    BaseButton,
    BaseRadio,
  },
  data() {
    return {
      LABEL_CONSTANTS,
      ALARM_TYPE_ITEMS,
      NO_CLAIMS_CONTENTS_ITEMS,
      NO_CLAIMS_BUILDINGS_ITEMS,
      form: PROPERTY_DETAILS_FORM,
      hasPreviousLandlordsCover: false,
      ADDRESS_FINDER_INPUT_DESCRIPTION,
    };
  },
  computed: {
    ...mapState(QUESTIONS_MODULE, ["restoringLastStep", "questionMap"]),
    ...mapGetters(QUESTIONS_MODULE, ["allSections", "propertyDetailsAnswer"]),
    disableContinue() {
      return this.checkDisableContinue();
    },
    isBuildingsOnly() {
      const coverTypeValue = this.questionMap.CoverType;
      return !includesContents(coverTypeValue);
    },
    alarmTypeOptions() {
      return setItemDataUiids("AlarmType", ALARM_TYPE_ITEMS);
    },
    noClaimContentOptions() {
      return setItemDataUiids("NoClaimsContents", NO_CLAIMS_CONTENTS_ITEMS);
    },
    noClaimBuildingOptions() {
      return setItemDataUiids("NoClaimsBuildings", NO_CLAIMS_BUILDINGS_ITEMS);
    },
  },
  watch: {
    // reset data of question related to non routine build work
    "form.nonRoutineBuildingWork.Value"(value) {
      if (value !== "true" && value !== true) {
        this.form.nonRoutineBuildingWorkValue.Value = "";
        this.form.nonRoutineBuildingWorkJctContract.Value = null;
      } else {
        if (this.form.nonRoutineBuildingWorkJctContract.Value === null) {
          this.form.nonRoutineBuildingWorkJctContract.Value = false;
        }
      }
    },
  },
  async mounted() {
    scrollTop();
    this.initDataFromStorage();
    this.setCurrentRefObserverForm(this.$refs.observerFormPropertyDetails);
    if (!this.restoringLastStep) {
      return;
    }
    // work around running validate before the data has been added to input
    setTimeout(async () => {
      tryGoToNextStep(
        this.$refs.observerFormPropertyDetails,
        (form) => form.validate(),
        ROUTE_NAME.LANDLORDS.D2C.COVER_DETAILS
      );
    }, 0);
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, [
      "saveProgress",
      "toggleGlobalSaveAndExitDialog",
      "setCurrentRefObserverForm",
    ]),

    async onSubmit(invalid) {
      if (invalid) {
        EventBus.$emit("validation-error", "Validation error occurred");
        return;
      }
      this.prepareDataForSubmit();
      this.saveProgress();
      this.$router.push({ name: ROUTE_NAME.LANDLORDS.D2C.COVER_DETAILS });
    },
    saveAndExit() {
      this.prepareDataForSubmit();
      this.toggleGlobalSaveAndExitDialog(EXIT_DESTINATION.landlordWelcomePage);
    },
    prepareDataForSubmit() {
      this.questionMap.NonRoutineBuildingWorkValue.Value = numeral(
        this.form.nonRoutineBuildingWorkValue.Value
      ).value();
    },
    backToYourDetail() {
      this.$router.push({ name: ROUTE_NAME.LANDLORDS.D2C.YOUR_DETAILS });
    },
    initDataFromStorage() {
      this.form.windowLocksFitted = this.questionMap.WindowLocksFitted;
      if (this.form.windowLocksFitted) {
        this.form.windowLocksFitted.Value = convertToBool(
          this.form.windowLocksFitted.Value
        );
      }
      this.form.alarmType = this.questionMap.AlarmType;

      this.form.unoccupiedNinetyDays = this.questionMap.UnoccupiedNinetyDays;
      if (this.form.unoccupiedNinetyDays) {
        this.form.unoccupiedNinetyDays.Value = convertToBool(
          this.form.unoccupiedNinetyDays.Value
        );
      }

      this.form.nonRoutineBuildingWork =
        this.questionMap.NonRoutineBuildingWork;
      if (this.form.nonRoutineBuildingWork) {
        this.form.nonRoutineBuildingWork.Value = convertToBool(
          this.form.nonRoutineBuildingWork.Value
        );
      }

      this.form.nonRoutineBuildingWorkValue = dereference(
        this.questionMap.NonRoutineBuildingWorkValue
      );
      if (this.form.nonRoutineBuildingWorkValue?.Value) {
        this.form.nonRoutineBuildingWorkValue.Value =
          this.form.nonRoutineBuildingWorkValue.Value.toString();
      }
      this.form.nonRoutineBuildingWorkJctContract =
        this.questionMap.NonRoutineBuildingWorkJctContract;

      if (this.form.nonRoutineBuildingWorkJctContract?.Value) {
        this.form.nonRoutineBuildingWorkJctContract.Value = convertToBool(
          this.form.nonRoutineBuildingWorkJctContract.Value
        );
      }

      this.form.studentTenants = this.questionMap.StudentTenants;
      if (this.form.studentTenants) {
        this.form.studentTenants.Value = convertToBool(
          this.form.studentTenants.Value
        );
      }

      this.form.dssTenants = this.questionMap.DssTenants;
      if (this.form.dssTenants) {
        this.form.dssTenants.Value = convertToBool(this.form.dssTenants.Value);
      }

      this.hasPreviousLandlordsCover =
        this.questionMap.PreviousLandlordsCover.Value;

      this.form.noClaimsBuildings = this.questionMap.NoClaimsBuildings;
      if (
        this.form.noClaimsBuildings &&
        (!this.form.noClaimsBuildings.Value || !this.hasPreviousLandlordsCover)
      ) {
        this.form.noClaimsBuildings.Value = "Two";
      }
      this.form.noClaimsContents = this.questionMap.NoClaimsContents;
      if (
        this.form.noClaimsContents &&
        (!this.form.noClaimsContents.Value || !this.hasPreviousLandlordsCover)
      ) {
        this.form.noClaimsContents.Value = "Two";
      }
      this.form.findProperty = this.questionMap.FindProperty;
    },
    checkDisableContinue() {
      return (
        this.propertyDetailsAnswer.NumberOfBathrooms === "NinePlus" ||
        this.propertyDetailsAnswer.NumberOfBedrooms === "NinePlus"
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.work-value__input {
  max-width: 237px;
}
</style>
